import React from "react";

import "./color-dot.css";

export function ColorDot({
	color,
	isActive = false,
	colorStyle,
	onClick,
	className,
	style,
}: {
	color: eXpress.HexColorString;
	isActive?: boolean;
	colorStyle?: eXpress.core.TextColorStyle;
	onClick?(): void;
	className?: string;
	style?: React.CSSProperties;
}) {
	return (
		<button
			type="button"
			className={`color-dot ${isActive ? "color-dot--active" : ""} ${className || ""}`}
			style={{
				backgroundColor: color,
				...style,
			}}
			onClick={onClick}
		>
			{colorStyle === "fluo" && <span className="color-dot__fluo">FLUO</span>}
			{colorStyle === "gold" && <span className="color-dot__gold">GOLD</span>}
		</button>
	);
}
